import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import HeaderComponent from "../../components/Header";
import Footer from "../../components/Footer/footer";
import { constants } from "../../Constants";
import Swal from "sweetalert2";
import { history, validateFields, validationEmail } from "../../helpers";
import Select from 'react-select';
import './addFamilyMemberForm.css';
import { familyMemberAction } from "../../store/actions";
import { familyMemberService } from "../../services/familyMember.service";
import Loading from '../../components/Loading/Loading';

const selectStyles = {
    option: (provided, state) => ({
        ...provided,
        borderBottom: "1px ",
        color: state.isSelected ? "black" : "",
        fontSize: 16,
        backgroundColor: state.isSelected ? "#eee" : "",
        textAlign: "left",
        cursor: "pointer",
    }),
    container: base => ({
        ...base,
        width: '100%',
    }),
    control: base => ({
        ...base,
        backgroundColor: '#F7F7F7',
        fontSize: 15,
        height: 45,
        borderRadius: "10px",
        width: "100%",
        textAlign: "left",
        cursor: "pointer"
    }),
    valueContainer: base => ({
        ...base,
        className: 'sh-input-text member-input-feild '
    })
};

class AddFamilyMember extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name: '',
            emailAddress: '',
            selectedRelation: null,
            relations: [],
            errorEmail: false,
            isDisabledSubmitButton: true,
        };
    }
    componentDidMount() {
        this.props.getRelationList();
    }
    componentWillReceiveProps(nextProps) {
        let relationList = []
        nextProps.familyMembers &&
            Array.isArray(nextProps.familyMembers.relations) &&
            nextProps.familyMembers.relations.length > 0
            && nextProps.familyMembers.relations.forEach(relation => {
                relationList.push({ ...relation, label: relation.name })
            })
        this.setState({
            relations: relationList,
        });
    }
    handleChange = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value }, this.submitBtnHandler);
    };

    handleRelationChange = (selectedOption) => {
        this.setState({ selectedRelation: selectedOption }, this.submitBtnHandler);
    };

    handleCancel = () => {
        Swal.fire({
            title: constants.DELETE_CONFORM_HEADER_TXT,
            text: constants.LEAVE_SCREEN_MSG,
            type: constants.QUESTION_TYPE_TXT,
            reverseButtons: true,
            showCancelButton: true,
            confirmButtonColor: constants.CONFIRM_BUTTON_COLOUR,
            cancelButtonColor: constants.CANCEL_BUTTON_COLOUR,
            cancelButtonText: constants.NO_TXT,
            confirmButtonText: constants.YES_TXT,
        }).then((result) => {
            if (result.value) {
                this.props.history.goBack();
            }
        });
    }

    submitBtnHandler = () => {
        const { name, emailAddress, selectedRelation } = this.state;
        const isNameValid = name && name.trim() !== "";
        const isEmailValid = emailAddress && emailAddress.trim() !== "";
        const isDisabledSubmitButton = !(isNameValid && isEmailValid && selectedRelation);
        this.setState({ isDisabledSubmitButton });
    };


    handleSubmit = async () => {
        const { name, emailAddress, selectedRelation } = this.state;
        // Validate all feilds before proceeding
        const isValid = validateFields(name,emailAddress,selectedRelation);
        if (!isValid) {
            return;
        }
        this.setState({ isDisabledSubmitButton: true });
        const payload = {
            name,
            email_address: emailAddress,
            patient_relation: selectedRelation.code
        };
        try {
            await familyMemberService.addFamilyMember(payload);
            Swal.fire({
                title: constants.CONGRATULATION,
                text: constants.FMAILY_MEMBER_ADD_SUCCESS_TXT,
                confirmButtonText: constants.OK_TXT
            }).then(() => {
                history.push('/family_member');
            });

        } catch (error) {
            let errorMessage = constants.GENERAL_ERROR_TXT;
            if (error && error.error) {
                try {
                    const errorObject = JSON.parse(error.error.replace(/'/g, '"')) || null;
                    if (errorObject) {
                        const usernameError = errorObject.username && errorObject.username[0] || null;
                        const emailAddressError = errorObject.email_address && errorObject.email_address[0] || null;
        
                        const errorCode = (() => {
                            if (usernameError && emailAddressError) return 'BothErrors';
                            if (usernameError) return 'userNameError';
                            if (emailAddressError) return 'emailAddressError';
                            return 'UnknownError';
                        })();
                        switch (errorCode) {
                            case 'BothErrors':
                                errorMessage = constants.FMAILY_MEMBER_NAME_EMAIL_ALREADYEXIST_TXT;
                                break;
                            case 'userNameError':
                                errorMessage = usernameError;
                                break;
                            case 'emailAddressError':
                                errorMessage = emailAddressError;
                                break;
                            default:
                                errorMessage = constants.GENERAL_ERROR_TXT;
                        }
                    } else {
                        errorMessage = error.error;
                    }
                } catch (parseError) {
                    errorMessage = error.error;
                }
            } else {
                errorMessage = constants.GENERAL_ERROR_TXT;
            }

            Swal.fire({
                title: constants.FMAILY_MEMBER_ERROR_TEXT,
                text: errorMessage,
                confirmButtonText: constants.OK_TXT
            });
        }
    };

    render() {
        const { loading } = this.props.familyMembers;

        if (loading) {
            return <Loading />;
        }
        return (
            <div className="sh-layout hoffen-block">
                <HeaderComponent />
                <div className="sh-create-apointment-comp sh-gnrl-width">
                    <div className="sh-gnrl-welcome-note">
                        <h2 className="sh-gnrl-welcome">
                            {constants.ADD_FMAILY_MEMBER_TXT.toUpperCase()}
                        </h2>
                    </div>
                    <div className="sh-gnrl-apointment-cont">
                        <div className="inner">
                            {/* Name Field */}
                            <div className="sh-gnrl-form-group">
                                <label htmlFor="member_name">{constants.NAME}</label>
                                <input
                                    autoComplete="off"
                                    value={this.state.name}
                                    required
                                    type="text"
                                    name="name"
                                    className="sh-input-text member-input-feild"
                                    onChange={this.handleChange}
                                    placeholder={constants.ENTER_NAME_TXT}
                                />
                            </div>

                            {/* Email Address Field */}
                            <div className="sh-gnrl-form-group">
                                <label htmlFor="emailAddress" className="email-label">
                                    {constants.EMAIL}
                                </label>
                                <input
                                    autoComplete="off"
                                    id='emailAddress'
                                    value={this.state.emailAddress || ''}
                                    required
                                    type="email"
                                    name="emailAddress"
                                    onChange={this.handleChange}
                                    className={`sh-input-text member-input-feild ${this.state.errorEmail && 'sh-input-error'} ${this.state.emailAddress && 'sh-input-active'}`}
                                    placeholder={constants.ENTER_EMAIL_TXT}
                                />
                            </div>

                            {/* Relation Field */}
                            <div className="sh-gnrl-form-group">
                                <label htmlFor="relation">{constants.FMAILY_MEMBER_RELATION_TXT}</label>
                                <Select
                                    id="sh_familyMember_selector"
                                    styles={selectStyles}
                                    options={this.state.relations}
                                    value={this.state.selectedRelation}
                                    onChange={this.handleRelationChange}
                                    placeholder={constants.SELECT_REALTION_TXT}
                                />
                            </div>

                            <div className="sh-grnl-row">
                                <span className="sh-gnrl-error-msg" id="sh_error_message">
                                    {this.state.errorEmail}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className="sh-btn-box">
                        <button className="sh-gnrl-btn sh-gnrl-cancel-btn" onClick={this.handleCancel} id='btnCancel'>
                            {constants.CANCEL_TXT}
                        </button>
                        <button className="sh-gnrl-btn sh-gnrl-sumit-btn" disabled={this.state.isDisabledSubmitButton} onClick={this.handleSubmit} id='btnSubmit'>
                            {constants.SUBMIT_TXT}
                        </button>
                    </div>
                </div>
                <Footer />
            </div>
        );
    }
}

function mapStateToProps(state) {
    const { auth, familyMembers } = state;
    const { user } = auth;
    return {
        user,
        familyMembers
    };
}

const mapDispatchToProps = (dispatch) => {
    return {
        getRelationList: () => {
            dispatch(familyMemberAction.getRelationList());
        },
    };
};
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AddFamilyMember));




// WEBPACK FOOTER //
// ./src/screens/AddFamilyMemberForm/index.js